// Présentation uniquement : ni la note historique ni la tâche ne sont modifiées.
export function automaticRelanceDisplay(note) {
    // Un nom affiché « Système » n'est pas une preuve de création automatique.
    if (note?.kind !== 'task_event' || note.author_id !== 'system_overdue_cron') return null;
    const [firstLine = '', ...details] = String(note.content || '').split('\n');
    const historicalTitle = firstLine.match(/^📋\s*Tâche \(backfill\)\s*:\s*«\s*(.*?)\s*»\s*$/u);
    // Le statut figé dans le texte historique (« Statut : À faire ») est retiré : le badge live fait foi.
    const stripStatus = (txt) => String(txt || '').replace(/\s*·?\s*Statut\s*:\s*[^·\n]*/gu, '').replace(/\n{2,}/g, '\n').trim();
    const content = stripStatus(historicalTitle
        ? [historicalTitle[1].replace(/^Dossier en retard(?: \(VP Direct\))? — relancer /u, 'Relancer '), ...details].join('\n')
        : note.content);
    return {
        title: 'Relance automatique · Dossier à suivre',
        author: 'Uatu · Rappel automatique',
        content,
    };
}